import type { SavedSearchesDto } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/types/dto";
import type { IListPageApiService } from "app/pages/sales-intelligence/modules/lists/sub-modules/my-list/services/api/types";
import type { ListsDto, StaticListDto } from "app/pages/sales-intelligence/modules/lists/types/dto";
import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

const LIST_PATH_PREFIX = "/sales-api/user-assets";
const createListPageAPIService = (fetchService: Readonly<IFetchService>): IListPageApiService => {
    return {
        fetchStaticLists(
            params: Readonly<{ page: number; pageSize: number; searchText: string }>,
            options?: Readonly<GetRequestOptions>,
        ): Promise<ListsDto<StaticListDto>> {
            return fetchService.get(`${LIST_PATH_PREFIX}/opportunity-lists`, params, options);
        },

        fetchSavedSearches(
            params: Readonly<{ page: number; pageSize: number; searchText: string }>,
            options?: Readonly<GetRequestOptions>,
        ): Promise<ListsDto<SavedSearchesDto>> {
            return fetchService.get(`${LIST_PATH_PREFIX}/saved-searches`, params, options);
        },
    };
};

export default createListPageAPIService;
